import { useTranslation } from "react-i18next";
import ManufacturingCard from "../tkdn/ManufacturingCard";
import ProjectCard from "../tkdn/ProjectCard";
import css from "./VKIVIU.module.css";

function Provision() {
  const { t } = useTranslation();

  const legal_basis = [
    {
      title: "Peraturan Menteri Perdagangan Nomor 16 Tahun 2025",
      url: "https://drive.google.com/file/d/1FRS8Hmu9JC8vPRBrsqaZFNN2jkwS4k1x/view?usp=sharing",
    },
    {
      title: "Peraturan Menteri Perdagangan Nomor 17 Tahun 2025",
      url: "https://drive.google.com/file/d/1w0j-mGFWGE_f11C2_2SPzyhpaS52-x2F/view?usp=sharing",
    },
    {
      title: "Peraturan Menteri Perindustrian Nomor 27 Tahun 2025",
      url: "https://drive.google.com/file/d/1Zw8cscNedyOPo8oea0TTW0MthRkXiwBX/view?usp=sharing",
    },
    {
      title:
        "Keputusan Direktur Jenderal Industri Kimia, Farmasi, dan Tekstil Kementerian Perindustrian Nomor 22/2026",
      url: "https://drive.google.com/file/d/1pJE4dW6lgtSU0skzHeNqKM6EMFmSMRgS/view?usp=sharing",
    },
  ];

  const document = [
    {
      title: "VKI",
      url: "https://drive.google.com/file/d/1MyeXF7tQWR-4glyEX07EDEGIzUdlOwJ8/view?usp=sharing",
    },
    {
      title: "VIU Industri",
      url: "https://drive.google.com/file/d/1y_EbymPsQ7eUSRfQpMsehOiopbb0_q0G/view?usp=sharing",
    },
    {
      title: "VIU Non-Industri",
      url: "https://drive.google.com/file/d/1KQHupkf4mjqXov1SfFDQeTtaa8dIpzMy/view?usp=sharing",
    },
    {
      title: "VIU Konsumsi",
      url: "https://drive.google.com/file/d/1wVuuKyxGa5NneHBSmpEOscFYCK0zlW-Q/view?usp=sharing",
    },
  ];

  return (
    <>
      <div className="tkdn-container-definition">
        <div className="tkdn-section-header">
          <div className="border-title-vpti" />
          <h1 className="tkdn-section-title">{t("vkiviu_laws.title")}</h1>
        </div>
        <div className={css.lawContainer}>
          <div className={css.lawList}>
            <h2 className="tkdn-subtitle">
              {t("vkiviu_laws.legal_basis.title")}
            </h2>
            {legal_basis.map((item, i) => (
              <ManufacturingCard
                index={i + 1}
                title={t(`vkiviu_laws.legal_basis.list.${i}.name`)}
                desc={t(`vkiviu_laws.legal_basis.list.${i}.desc`)}
                url={item.url}
              />
            ))}
          </div>
          <div className={css.lawList}>
            <h2 className="tkdn-subtitle">{t("vkiviu_laws.document.title")}</h2>
            {document.map((item, i) => (
              <ProjectCard
                index={i}
                title={t(`vkiviu_laws.document.list.${i}`)}
                url={item.url}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
export default Provision;
